import React, { Component } from "react";
import Constant from "../../Constant";
import { Link } from "react-router-dom";
import QuestionContainer from "../Create/quiz/QuestionContainer";
import CourseContainer from "../Create/HTML/CourseContainer";
import Youtube from "../trainer/unit/Youtube";
import Video from "../trainer/unit/Video";
import Audio from "../trainer/unit/Audio";
import TextPdf from "../trainer/unit/TextPdf";
//import HtmlUpload from '../trainer/unit/HtmlUpload';

export default class EditTopic extends Component {
  constructor(props) {
    super();
    this.state = {
      data: [],
      courseName: "",
      courseDisc: "",
      content: {
        elements: [],
      },
      courseID: props.match.params.course_id,
      questionsList: [{ game_type_id: "" }],
    };
  }

  componentDidMount = () => {
    this.getCourse();
    this.getTopic();
  };
  getCourse() {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", this.props.match.params.course_id);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/course/getOne", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data;
        console.log(data);

        this.setState({
          courseName: data.name,
          courseDisc: data.description,
          courseImage: data.image,
        });
        this.setState({ course: data, loading: false });
      })
      .catch((error) => console.log("error", error));
  }
  getTopic = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", localStorage.getItem("livelms_auth"));

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("topicId", this.props.match.params.topic_id);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/topic/getOne", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var content = JSON.parse(result.data.content);
        console.log(content);
        if (content.topicType == 4) {
          var questionsList = content.data;
          this.setState({ questionsList: questionsList });
        } else if (content.topicType == 6) {
          var htmlContent = content.data;
          this.setState({ htmlContent: htmlContent });
        }
        console.log("Result Data", result.data);
        this.setState({ data: result.data, content: content });
      })
      .catch((error) => console.log("error", error));
  };
  render() {
    console.log("data", this.state.data);
    return (
      <div>
        {this.state.content.topicType == 4 ? (
          <QuestionContainer
            questionsList={this.state.questionsList}
            unitDetails={this.state.data}
            topic_id={this.props.match.params.topic_id}
            course_id={this.props.match.params.course_id}
          />
        ) : this.state.content.topicType == 6 ? (
          <CourseContainer
            currentPage={this.state.htmlContent}
            editMode={true}
            unitDetails={this.state.data}
            topic_id={this.props.match.params.topic_id}
            course_id={this.props.match.params.course_id}
          ></CourseContainer>
        ) : (
          <div className="p-5">
            <div className="container border shadow-sm p-0 bg-white">
              <div className="header bg-primary text-white">
                <div className="row m-0">
                  <div className="col-md-8 p-3 d-flex align-items-center">
                    <h5 className="m-0">
                      {localStorage.getItem("livelms_role") !== "learner" ? (
                        <span>
                          <Link to="/admin/dashboard">Home</Link> /{" "}
                          <Link to="/admin/courses">Courses</Link> /{" "}
                          <Link
                            to={`/admin/course/topics/${this.props.match.params.course_id}`}
                          >
                            {this.state.courseName}
                          </Link>{" "}
                          / {this.state.data.name}
                        </span>
                      ) : (
                        <span>
                          <Link to="/learner/course-list">Home</Link> /{" "}
                          <Link to="/learner/course-list">Courses</Link> /{" "}
                          <Link
                            to={`/learner/course/${this.props.match.params.course_id}`}
                          >
                            {this.state.courseName}
                          </Link>{" "}
                          / {this.state.data.name}
                        </span>
                      )}
                    </h5>
                  </div>
                  <div className="col-md-4 d-flex justify-content-end align-items-center">
                    {localStorage.getItem("livelms_role") !== "learner" ? (
                      <Link
                        to={`/admin/edit-topic/${this.props.match.params.course_id}&${this.props.match.params.topic_id}`}
                        className="btn btn-dark float-right"
                      >
                        Edit Topic
                      </Link>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <div className="users-container p-4">
                {/* <div className="mw-100 mh-100 bg-danger text-center"> */}
                {this.state.content.topicType == "youtube" ? (
                  <Youtube
                    data={this.state.courseID}
                    name={this.state.data.name}
                    desc={this.state.data.description}
                    image={this.state.data.image}
                    courseID={this.props.match.params.course_id}
                    topicID={this.props.match.params.topic_id}
                    videoURL={this.state.content.videoURL}
                  />
                ) : this.state.content.topicType == "video" ? (
                  <Video
                    data={this.state.courseID}
                    name={this.state.data.name}
                    desc={this.state.data.description}
                    image={this.state.data.image}
                    courseID={this.props.match.params.course_id}
                    topicID={this.props.match.params.topic_id}
                  />
                ) : this.state.content.topicType == "audio" ? (
                  <Audio
                    data={this.state.courseID}
                    name={this.state.data.name}
                    desc={this.state.data.description}
                    image={this.state.data.image}
                    content={this.state.content.video}
                    courseID={this.props.match.params.course_id}
                    topicID={this.props.match.params.topic_id}
                  />
                ) : this.state.content.topicType == "text" ? (
                  <TextPdf
                    data={this.state.courseID}
                    name={this.state.data.name}
                    desc={this.state.data.description}
                    image={this.state.data.image}
                    content={this.state.content.textFile}
                    courseID={this.props.match.params.course_id}
                    topicID={this.props.match.params.topic_id}
                  />
                ) : this.state.content.topicType == "html" ? (
                  {
                    /*
                  <HtmlUpload
                    data={this.state.courseID}
                    name={this.state.data.name}
                    desc={this.state.data.description}
                    content={this.state.content.value}
                    courseID={this.props.match.params.course_id}
                    topicID={this.props.match.params.topic_id}
                  />*/
                  }
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
